import SimpleCardHorizontalDivide from "./SimpleCardHorizontalDivide";

export default SimpleCardHorizontalDivide;
